import React from 'react'
import PropTypes from 'prop-types'
import Div from 'components/Div'
import AccordionContext from './AccordionContext'

class AccordionSection extends React.PureComponent {
  static propTypes = {
    id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
    Container: PropTypes.oneOfType([PropTypes.func, PropTypes.symbol, PropTypes.object, PropTypes.string]),
    renderHeader: PropTypes.func,
    renderContent: PropTypes.func,
    current: PropTypes.array.isRequired, // injected by AccordionContext
    onClick: PropTypes.func.isRequired, // injected by AccordionContext
    registerSection: PropTypes.func.isRequired // injected by AccordionContext
  }

  static defaultProps = {
    Container: React.Fragment,
    renderHeader: () => null,
    renderContent: () => null
  }

  componentDidMount () {
    const { id, registerSection } = this.props
    this.unregisterSection = registerSection(id)
  }

  componentDidUpdate (prevProps) {
    const { id, registerSection } = this.props
    if (id !== prevProps.id) {
      this.cleanup()
      this.unregisterSection = registerSection(id)
    }
  }

  componentWillUnmount () {
    this.cleanup()
  }

  cleanup = () => {
    typeof this.unregisterSection === 'function' && this.unregisterSection()
  }

  onClick = () => {
    const { id, onClick } = this.props
    onClick(id)
  }

  render () {
    const { id, current, Container, renderHeader, renderContent, ...props } = this.props
    const show = current.indexOf(id) > -1

    return (
      <Container>
        <Div role='button' {...props} id={id} onClick={this.onClick} >
          {renderHeader({ show })}
        </Div>
        {renderContent({ show })}
      </Container>
    )
  }
}

const AccordionSectionWrapper = (props) => (
  <AccordionContext.Consumer>
    {({ show, onClick, registerSection }) => (<AccordionSection {...props} registerSection={registerSection} current={show} onClick={onClick} />)}
  </AccordionContext.Consumer>
)

export default AccordionSectionWrapper
